import { createLazyComponent, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "FilterContextMenu" */ './lazyIndex');
});
// Delay loaded components
export var MailFilterContextMenu = createLazyComponent(lazyModule, function (m) { return m.MailFilterContextMenu; });
export var MailListFilter = createLazyComponent(lazyModule, function (m) { return m.MailListFilter; });
//# sourceMappingURL=index.js.map